import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useI18n } from '@/contexts/I18nContext';

const NotFound = () => {
  const location = useLocation();
  const { tp } = useI18n();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">{tp.notFound.errorCode}</h1>
        <p className="mb-4 text-xl text-gray-600">{tp.notFound.title}</p>
        <a href="/" className="text-blue-500 underline hover:text-blue-700">
          {tp.notFound.homeLink}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
